function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//var qb = require('./questionBundle');
var qb = require('../../../resources/questionBundle');
// /Users/patrick/Library/Application Support/Google/Chrome/Default/IndexedDB

var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
//var IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction || {READ_WRITE: "readwrite"}; // This line should only be needed if it is needed to support the object's constants for older browsers
//var IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;
// (Mozilla has never prefixed these objects, so we don't need window.mozIDB*)
let indexDbKeys = [];
var storage = null;
let db = null;
var needs_import = true;
function openDatabase(name) {
  return new Promise(function (resolve, reject) {
    if (db) {
      return resolve(db);
    }
    const req = indexedDB.open(name, 5);
    req.addEventListener("upgradeneeded", ev => {
      db = req.result;
      if (ev.oldVersion < 1) {
        db.createObjectStore("people", {
          keyPath: "name"
        });
      }
      needs_import = true;
    });
    req.addEventListener("success", () => {
      db = req.result;
      if (needs_import) {
        needs_import = false;
        // migrate data from localstorage

        initializePersonas();
        migrateLocalStorageData(db).then(() => {
          resolve(db);
        }).catch(e => {
          console.log(e);
        });
      }
    });
  });
}
function promiseFromRequest(req) {
  return new Promise(function (resolve, reject) {
    req.addEventListener("error", () => reject());
    req.addEventListener("success", () => resolve(req.result));
  });
}
function walletFromData(data) {
  var wallet = JSON.parse(data);
  if (wallet && wallet.fhir && typeof wallet.fhir === 'string') {
    if (wallet.fhir[0] == '{') {
      wallet = JSON.parse(wallet.fhir);
    } else {
      wallet = null;
    }
  }
  if (typeof wallet === 'string') {
    if (wallet[0] == '{') {
      wallet = JSON.parse(wallet);
    } else {
      wallet = null;
    }
  }
  return wallet;
}
async function migrateLocalStorageData(db) {
  const tx = db.transaction(["people"], "readwrite");
  const tbl = tx.objectStore("people");

  // Create a cursor to iterate through the keys
  let cursorRequest = tbl.openCursor();
  indexDbKeys = await getKeysIndexedDB(cursorRequest);
  let personaLst = window.localStorage.getItem("personas").split(",");
  var reqs = [];
  let personaDeletelst = [];
  for (var i = 0, len = localStorage.length; i < len; ++i) {
    let key = localStorage.key(i);
    if (key.endsWith("Data") && key != 'errorData') {
      var name = key.substring(0, key.length - 4);
      personaDeletelst.push(name);
      if (!indexDbKeys.includes(name)) {
        var data = localStorage.getItem(key);
        var wallet = walletFromData(data);
        data = JSON.parse(data);
        var bundles = [];
        var bundle = localStorage.getItem(name + "Bundle");
        if (bundle) {
          bundle = JSON.parse(bundle);
          bundles.push(bundle);
        }
        var record = {
          bundles: bundles,
          wallet: wallet,
          data: data,
          name: name
        };
        if (wallet) {
          reqs.push(promiseFromRequest(tbl.put(record)));
        }
      }
    }
  }
  //add persona indexedDb if personas are available in persona list and not in indexeddb
  personaLst.forEach(function (personaToadd) {
    if (!indexDbKeys.includes(personaToadd)) {
      addPersona(personaToadd);
    }
  });
  personaDeletelst.forEach(personaNameTodelete => {
    localStorage.removeItem(personaNameTodelete + "Data");
  });
  return Promise.all(reqs);
}
//not in use removed it
/*async function migratewalletFhirData(fhirData) {
    var name = getSelectedPersona();
    var existingData = await module.exports.get(name);
    await module.exports.mergedData(name, existingData.data, fhirData)
}*/
function initializePersonas() {
  let defaultPersonas = 'me,spouse,parent,child,patient,provider';
  var defaultPersonasArray = defaultPersonas.split(',');
  if (!localStorage.getItem('personas')) {
    localStorage.setItem('personas', defaultPersonas);
    defaultPersonasArray.forEach(persona => addPersona(persona));
  }
}
if (indexedDB) {
  storage = {
    query: async function (name) {
      const db = await openDatabase("wallet");
      const tx = db.transaction(["people"], "readonly");
      const tbl = tx.objectStore("people");
      const req = tbl.get(name);
      return await promiseFromRequest(req);
    },
    deletePersonaData: async function (name) {
      //let OldNameData = await module.exports.get(oldName);
      const tx = db.transaction(["people"], "readwrite");
      const tbl = tx.objectStore("people");
      tbl.delete(name);
    },
    store: async function (data) {
      const tx = db.transaction(["people"], "readwrite");
      const tbl = tx.objectStore("people");
      const req = tbl.put(data);
      return await promiseFromRequest(req);
    }
  };
  // initializePersonas();
  openDatabase("wallet"); // forces migration on startupo
} else {
  // fallback to local storage
  storage = {
    query: async function (name) {
      var data = localStorage.getItem(name + 'Data');
      if (data) {
        var wallet = walletFromData(data);
        return {
          bundles: [],
          wallet: wallet,
          data: data,
          name: name
        };
      }
      return null;
    },
    store: async function (data) {
      localStorage.setItem(data.name + 'Data', JSON.stringify(data));
    }
  };
}
function allPersonaNames() {
  // persona default names
  var personas = localStorage.getItem('personas') || 'me,spouse,parent,child,patient,provider';
  personas = personas.split(',').map(p => p.trim());
  return personas;
}
//todo not used 
async function findPatient(first_name, last_name, date_of_birth) {
  var personas = allPersonaNames();
  for (var i = 0; i < personas.length; i += 1) {
    var personaName = personas[i];
    var data = await storage.database.query(personaName);
    if (data && data.wallet && data.wallet.item) {
      var pd = data.wallet;
      var demographics = pd.item.find(q => q.text == "Demographics") || {};
      if (demographics && demographics.item) {
        var p_first_name = qb.answerForLinkId(demographics.item, "/demographics/first_name");
        var p_last_name = qb.answerForLinkId(demographics.item, "/demographics/last_name");
        var p_date_of_birth = qb.answerForLinkId(demographics.item, "/demographics/date_of_birth");
        if (first_name.length > 0 && first_name == p_first_name) {
          // at least their first name should match
          var matched = true;
          if (last_name.length > 0 && p_last_name.length > 0 && last_name.toLowerCase() != p_last_name.toLowerCase()) {
            matched = false;
          }
          if (date_of_birth.length > 0 && date_of_birth.length > 0 && date_of_birth != p_date_of_birth) {
            matched = false;
          }
          if (matched) {
            return data;
          }
        }
      }
    }
  }
  return null;
}
async function getKeysIndexedDB(cursorRequest) {
  return new Promise((resolve, reject) => {
    cursorRequest.onsuccess = event => {
      const cursor = event.target.result;
      if (cursor) {
        // The cursor.value contains the data, and cursor.key contains the key
        const key = cursor.key;
        if (!indexDbKeys.includes(key)) {
          indexDbKeys.push(key);
        }

        // Move to the next item
        cursor.continue();
      } else {
        // No more items
        resolve(indexDbKeys);
      }
    };
  });
}

// exported to add new persona
async function addPersona(name) {
  //var personas = allPersonaNames();
  let wallet = {};
  let data = {};
  await module.exports.store(name, data, wallet);

  // var value = 0;
  var newName = name;
  let personaData = await window.personaService.get(name); //ORV240308 persona data to update wallet
  let walletDiv = __g_zPDF_formHelper__.lwcTemplate.querySelector(".wallet-content"); //ORV240308 get wallet div
  walletDiv.querySelector("iframe")?.contentWindow.postMessage(personaData); //ORV240308 refresh wallet iframe so correct data is populated in wallet.html
  // localStorage.setItem('personas', personas.join(','));
  return newName;
}
async function addRenamedPersona(name, oldValue) {
  let OldNameData = await module.exports.get(oldValue);
  var bundles = [];
  var data = {};
  var wallet = {};
  if (OldNameData?.bundle) {
    bundles = OldNameData.bundle;
  }
  if (OldNameData?.data) {
    data = OldNameData.data;
  }
  if (OldNameData?.wallet) {
    wallet = OldNameData.wallet;
  }
  await module.exports.store(name, data, wallet);
}
//TODO  exported not used
function mergeData(data1, data2) {
  //assuming that both attributes have value
  let mergedObject = _objectSpread({}, data1); // creating a second copy of the input param 
  let keys = Object.keys(data2);
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    console.log("AHS230828 - what is the key? : ", key);
    if (data2.hasOwnProperty(key)) {
      if (key == 'data' && typeof data2[key] == 'object') {
        mergedObject[key] = mergedObject[key] || {};
        mergedObject[key] = _objectSpread(_objectSpread({}, mergedObject[key]), data2[key]);
      } else {
        mergedObject[key] = data2[key];
      }
    }
  }
  return mergedObject;
}
module.exports = {
  //returns the list of persona in indexedDb
  names: function () {
    return allPersonaNames();
  },
  //gets the value for persona from indexedDb
  get: async function (name) {
    return await storage.query(name);
  },
  //todo exported and used
  delete: async function (name, oldName) {
    await storage.deletePersonaData(name, oldName);
  },
  // stores the completed object in indexedDb based on persona
  store: async function (name, data, wallet, bundles) {
    // let bundles = [];
    var db = module.exports.indexedDbobject(name, bundles, wallet, data);
    return await storage.store(db);
  },
  //AHS230829 - this is used in data toolbar learn button

  storePersonaData: async function (data) {
    console.log("storePersonaDataSelected");
    __g_selectedPersonaData = data; //AHS230829 - any time we insert data in 
    return storage.store(__g_selectedPersonaData);
  },
  // adds the key from indexedDb when persona is deleted
  add: function (name, oldName) {
    return addPersona(name, oldName);
  },
  // removes the key from indexedDb when persona is deleted
  remove: async function (name) {
    await storage.deletePersonaData(name);
  },
  //renames the key from indexeddb when persona input name is updated 
  rename: async function (newName, oldName) {
    await addRenamedPersona(newName, oldName);
    await storage.deletePersonaData(oldName);
  },
  // todo exported but not used
  find: async function (first_name, last_name, date_of_birth) {
    return findPatient(first_name, last_name, date_of_birth);
  },
  // todo not used
  reset: function (names) {},
  // Stores wallet fhir data in indexdb
  storeWalletFhir: function (fhirData) {
    console.log("__g_selectedPersonaDataPersonajs", __g_selectedPersonaData); // page level variable for storing data related to the currently selected persona
    __g_selectedPersonaData.wallet = typeof fhirData === "string" ? JSON.parse(fhirData) : fhirData;
    __g_selectedPersonaData.name = getSelectedPersona();
    return storage.store(__g_selectedPersonaData);
    // migratewalletFhirData(fhirData)
  },
  indexedDbobject: function (name, bundles, wallet, data) {
    bundles = bundles || [];
    wallet = wallet || {};
    data = data || {};
    var db = {
      bundles: bundles,
      wallet: wallet,
      data: data,
      name: name
    };
    return db;
  },
  import: async function (data) {
    //TODO: remove name param, data should already have it
    //initialize data
    let name = getSelectedPersona();
    let personaLst = window.localStorage.getItem("personas").split(",");
    //check the format of data
    let dataKeys = Object.keys(data);
    let version = 1;
    // ORV240110   if(!personaLst.includes(data.name) && data.name &&  data.name.trim() !='') data.name is undefined user name
    if (!personaLst.includes(name) && name && name.trim() !== '') {
      //ORV240110 add name.trim() check to avoid empty persona storage
      personaLst.push(data.name);
      window.localStorage.setItem("personas", personaLst);
    }
    if (dataKeys.includes('bundles') || dataKeys.includes('wallet')) {
      //AHS250514 - Check for either wallet or bundles to determine if its version 2 format//! AHS230828 - Add the version field to the PDF Wallet at the time of creation
      version = 2; // v2 - bundle, fields learnt from PDF & fhir, persona name & wallet
      //   name = data.name
    } else {
      version = 1; // v1 - only fields learnt from PDF and fhir 
      let proceed = confirm(`We are merging the imported data in currently selected persona ${name}. Do we wish to continue?`); //if old format, mention which persona is it being imported in
      if (!proceed) {
        return;
      }
    }

    //if old format, reformat the data to match version 2 format
    if (version === 1) {
      let fhirQuestionnaireResponse;
      if (data.data) {
        let nestedData = data.data;
        delete data.data;
        data = _objectSpread(_objectSpread({}, data), nestedData);
      }

      //AHS230905 - we are imporing an older wallet, we have to tranform the fhir which is a stringified questionnaire response
      if (data.fhir) {
        data.fhir = JSON.parse(data.fhir);
        fhirQuestionnaireResponse = data.fhir;
        data.fhir = transformFromQuestionnaireResponseToBundle(data.fhir);
      }
      let oldWalletData = data;
      data = {};
      data.data = _objectSpread({}, oldWalletData);
      if (oldWalletData.fhir) {
        data.bundles = oldWalletData.fhir; //AHS230925 - should we push instead of reassign?
        data.wallet = fhirQuestionnaireResponse;
      }
    }

    //is the persona we are importing the currently selected persona
    let existingDataForimportedPersona = null;
    if (name === getSelectedPersona()) {
      existingDataForimportedPersona = __g_selectedPersonaData;
    } else {
      existingDataForimportedPersona = await storage.query(name);
    }
    if (existingDataForimportedPersona) {
      existingDataForimportedPersona = mergeData(existingDataForimportedPersona, data);
    } else {
      existingDataForimportedPersona = data;
    }
    await module.exports.store(name, existingDataForimportedPersona.data, existingDataForimportedPersona.wallet, existingDataForimportedPersona.bundles);
  },
  //!AHS230828 - I think it would be better to rename this as mergeAndStore. intenally it should call the merge function and store function
  //!AHS230828 - this method can be refactored
  //!AHS230918 - this function is called from learn button and is specific to current persona, remove the name param as it can confuse later.
  // 
  // merge the existing data and newly added for the selected persona so data is not lost it returns the complete object with keys bundle,wallet,name and data and thier values 
  mergePersonaData: async function (name, formData, fhirData) {
    let existingData = await module.exports.get(name);
    let mergedData = formData;
    console.log("name : ", name);
    console.log("mergedData : ", mergedData);
    if (existingData) {
      let keys = Object.keys(existingData);
      console.log("keys : ", keys);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (typeof existingData[key] === 'object' && key == 'data') {
          mergedData = _objectSpread(_objectSpread({}, existingData[key]), mergedData);
        }
      }
      let wallet;
      if (fhirData) {
        wallet = walletFromData(fhirData);
      } else if (existingData?.wallet) {
        wallet = existingData.wallet;
      }

      //__g_selectedPersonaData should already have the bundles present on it, hence we do not need to modify it
      __g_selectedPersonaData.data = mergedData;
      __g_selectedPersonaData.wallet = wallet; //? do we need this line?
      return __g_selectedPersonaData;
      //storage.store(__g_selectedPersonaData);

      // await module.exports.store(name, mergedData, wallet, bundles);
    }
  }
};
if (typeof window !== 'undefined') {
  window.personaService = module.exports;
}